import 'material-design-icons-iconfont/dist/material-design-icons.css' // Ensure you are using css-loader
import '@mdi/font/css/materialdesignicons.css' // Ensure you are using css-loader
import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.css'

Vue.use(Vuetify)

const opts = {
  // iconfont: 'mdi',
  theme: {
    defaultTheme: "dark",
    themes: {
      light: {
        primary: "#2877B8", // #00bcd4
        secondary: "#8bc34a",
        accent: "#3f51b5",
        error: "#EB265D", // #e91e63
        warning: "#ffeb3b",
        info: "#0097EE",
        success: "#30AB02" //#4caf50 //#00BF83
      },
      dark: {
        primary: "#2877B8", // #00bcd4
        secondary: "#8bc34a",
        accent: "#3f51b5",
        error: "#EB265D", // #e91e63
        warning: "#ffeb3b",
        info: "#0097EE",
        success: "#30AB02" //#4caf50 //#00BF83
      }
    }
  }
}

export default new Vuetify(opts);